import { Box, Stack, Typography } from "@mui/material";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import GlobalButton from "../../../components/CustomButton";
import CategoryServiceBlockDialog from "../../../components/Dialog/CategoryServiceBlockDialog";
import CategoryServiceFilterDialog from "../../../components/Dialog/CategoryServiceFilterDialog";
import DynamicTable from "../../../components/DynamicTable";
import appcolors from "../../../constants/Colors";
import DeleteServiceCategory from "./DeleteServiceDialog";

function Service(props) {
  const {
    handleSelect,
    services,
    handleEdit,
    setOpenConfirm,
    handleDelete,
    openConfirm,
    openConfirmDialog,
    handleChangeStatus,
    handleConfirm,
  } = props;
  const openFilterDialog = useRef(null);
  const openBlockDialog = useRef(null);
  const { user } = useSelector((state) => state.user);

  const renderRightPart = () => {
    return (
      <Stack
        gap={1}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <GlobalButton
          variant={"contained"}
          btnText={"Add New"}
          handleClickBtn={() => {
            let data = {
              type: "add",
            };
            handleSelect({ tab: "single", data });
          }}
          styleProps={{
            fontWeight: 400,
            fontSize: "0.875rem",
            height: 40,
            width: 120,
          }}
        />
      </Stack>
    );
  };
  return (
    <>
      <AppContainer
        primaryHeading={"All Services"}
        headProps={user?.role == "business" && renderRightPart()}
        handleFilterData={() => openFilterDialog.current.isVisible()}
      >
        {services?.length > 0 ? (
          <Box mb={2} mt={1}>
            {services?.map((item, ind) => {
              console.log(item, "itemitemitem123123");

              let tableHeader = [
                item?.name,
                "Cost",
                "Assinged Branch",
                "Tax",
                "Discount",
                "Actions",
              ];
              let displayRows = [
                "catalogue_name",
                "catalogue_cost",
                "assingedBranch",
                "tax",
                "discount",
                "actions",
              ];
              console.log(item?.services, "item?.servicesitem?.services");

              return (
                <DynamicTable
                  key={ind}
                  tableHeader={tableHeader}
                  displayRows={displayRows}
                  showEdit={true}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                  tableData={item?.services}
                  showPagination={false}
                  handleNavigate={() => console.log("ffff")}
                  handleChangeCatalogueStatus={handleChangeStatus}
                />
              );
            })}
          </Box>
        ) : (
          <Typography
            variant="h1"
            fontSize={23}
            textAlign={"center"}
            color={appcolors.black}
            mt={20}
            mb={20}
          >
            No Service Found!
          </Typography>
        )}
      </AppContainer>
      <CategoryServiceFilterDialog ref={openFilterDialog} />
      <CategoryServiceBlockDialog ref={openBlockDialog} />
      <DeleteServiceCategory
        ref={openConfirmDialog}
        handleConfirm={handleConfirm}
        open={openConfirm}
        setOpen={setOpenConfirm}
      />
    </>
  );
}

export default Service;
